import { render, staticRenderFns } from "./customerService.vue?vue&type=template&id=720f91dc&scoped=true&"
import script from "./customerService.vue?vue&type=script&lang=js&"
export * from "./customerService.vue?vue&type=script&lang=js&"
import style0 from "./customerService.vue?vue&type=style&index=0&id=720f91dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f91dc",
  null
  
)

export default component.exports